module.exports = __webpack_public_path__ + "img/profile-img.0e649a34.png";